module.exports = __webpack_public_path__ + "static/top-background-80ddbfa35b5f123f1105700c1126a464.jpg";